/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ActionType1/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import ActionType from './ActionType/index'
import Order from './Order/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ActionType1({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/ActionType"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="ActionType.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-ZwsRsr': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<Order
  viewPath={`${viewPath}/Order`}
/>
<div
  data-testid="ActionType.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="Do this"
/>
</div>
<ActionType
  viewPath={`${viewPath}/ActionType`}
/>
</div>
{children}
</React.Fragment>)
}